'use strict';

import UsersList from './users.list.ctrl';
import UsersNew from './users.new.ctrl';
import UsersEdit from './users.edit.ctrl';

export default angular
  .module('main.users', [
    UsersList,
    UsersNew,
    UsersEdit
  ])
  .name;
